<template>
    <section class="bg-white py-10" id="beneficios">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div
                    class="col-md-9 col-lg-6 order-1 order-lg-0"
                    data-aos="fade-right"
                >
                    <div class="content-skewed content-skewed-right">
                        <img
                            class="content-skewed-item img-fluid shadow-lg rounded-lg"
                            src="/layouts/site/contabilidade/assets/img/screenshots/landing-portfolio-betel.png"
                        />
                    </div>
                </div>
                <div
                    class="col-lg-6 order-0 order-lg-1 mb-5 mb-lg-0"
                    data-aos="fade-left"
                >
                    <div class="mb-5">
                        <h2>
                            Veja como a {{ app.nome }} vai ajudar sua empresa
                        </h2>
                        <p class="lead">
                            Com a nossa plataforma de contabilidade online você
                            automatiza as atividades contábeis, tributárias e
                            financeiras da sua empresa de modo simples e rápido:
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <h6>Emissão de notas fiscais simplificada</h6>
                            <p class="mb-2 small">
                                Tenha acesso a uma plataforma completa para
                                emitir suas NF-e, NFC-e e NFS-e sem limites de
                                emissão e de maneira bem simples.
                            </p>
                        </div>
                        <div class="col-md-6 mb-4">
                            <h6>
                                Calendário de obrigações e notificações de
                                atividades
                            </h6>
                            <p class="mb-2 small mb-0">
                                Dashboard de calendário que te deixará sempre
                                atualizado quanto às obrigações fiscais.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <h6>Gestão da sua empresa sem complicações</h6>
                            <p class="mb-2 small mb-0">
                                Tenha acesso a um poderoso ERP que vai auxiliar
                                em toda a gestão da sua empresa.
                            </p>
                        </div>
                        <div class="col-md-6 mb-4">
                            <h6>
                                Todas as informações da sua empresa em um só
                                lugar
                            </h6>
                            <p class="small mb-0">
                                Um módulo exclusivo que organizará todos os
                                documentos de forma digital e de fácil
                                localização.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="svg-border-rounded text-light">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 144.54 17.34"
                preserveAspectRatio="none"
                fill="currentColor"
            >
                <path
                    d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
                ></path>
            </svg>
        </div>
    </section>
</template>
<script>
export default {
    props: ['app']
}
</script>
